import { CommonModule } from "@angular/common";
import { Component, model, output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { CUSTOMER_STATUS, FUNCTION_RESULT_STATUS, ICustomer, IObjectAddress } from "@nova/common-interfaces";
import { IServicePlan, ISubscription, SUBSCRIPTION_STATUS } from "@rfm/shared-interfaces";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { TooltipModule } from "primeng/tooltip";
import { CustomerService } from "../../../shared/services/customers/customers.service.mjs";
import { SubscriptionService } from "../../../shared/services/products/subscription.service.mjs";
import { IGeographicalInformation } from "../../pages/dashboard/order-dashboard.component";
import { IPersonDetails } from "../setup-plan/setup-plan.component";

@Component({
  selector: "app-order-review",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
    ButtonModule,
    TooltipModule,
  ],
  templateUrl: "./review.component.html",
  styleUrl: "./review.component.scss",
})
export class OrderReviewComponent {
  termsAccepted: boolean = false;
  address = model<IObjectAddress | undefined>();
  geographical_information = model<IGeographicalInformation | undefined>();
  selectedPlan = model<IServicePlan | undefined>();
  personalDetails = model<IPersonDetails | undefined>();
  orderSaved = output<boolean>();
  

  constructor(private router: Router, private customerService: CustomerService, private subscriptionService: SubscriptionService) {
  }
  async submitOrder() {
    if (this.termsAccepted) {
      const customer = {
        name: this.personalDetails()?.firstName + " " + this.personalDetails()?.lastName,
        first_name: this.personalDetails()?.firstName,
        last_name: this.personalDetails()?.lastName,
        email: this.personalDetails()?.emailAddress,
        autopay_status: false,
        activation_date: 0,
        home_home: this.personalDetails()?.homePhone,
        mobile_phone: this.personalDetails()?.mobilePhone,
        status: CUSTOMER_STATUS.LEAD,
        total_balance: 0,
        latitude: this.geographical_information()?.latitude,
        longitude: this.geographical_information()?.longitude,
        mailing_address: this.address()
      } as ICustomer;

      await this.customerService.insert(customer).then(async result => {
        if (result.status === FUNCTION_RESULT_STATUS.SUCCESS)
        {
          const subscription = {
            actual_amount: this.selectedPlan()?.amount,
            amount: this.selectedPlan()?.amount,
            customer_id: result.data!,
            discount: 0,
            discount_expiry: 0,
            is_active: true,
            months_to_bill: 1,
            plan: this.selectedPlan(),
            activation_date: 0,
            cancellation_date: 0,
            status: SUBSCRIPTION_STATUS.PENDING,
            next_due: 0,
            data_download_mtd: 0,
            data_upload_mtd: 0,
            id: "",
            createdAt: 0,
            createdBy: "",
            updatedAt: 0, 
            updatedBy: ""
          } as ISubscription;

          await this.subscriptionService.insert(subscription).then(result => {
            if (result.status !== FUNCTION_RESULT_STATUS.SUCCESS)
            {
              this.orderSaved.emit(true);
            }
          })
          return Promise.resolve();
        }
          return Promise.reject();
      })

    } else {
      alert("Please accept the terms and conditions.");
    }
  }
}
